import { useLocation } from "react-router-dom"
import { ActivityList } from "./activityList"
import { Box } from "@mui/material"
import { Hashs } from "../activityRegister/utils"
import { ActivityDetail } from "../shared/detail"
import { CreateActivity } from "../shared/formActivity/create"
import { EditActivity } from "../shared/formActivity/edit"

export const MyActivity = () => {
    const location = useLocation()

    return (
        <Box>
            {location.hash.includes(Hashs.DETAIL) && (<ActivityDetail />)}
            {location.hash.includes(Hashs.CREATE) && (<CreateActivity goBack={{}} />)}
            {location.hash.includes(Hashs.EDIT) && (<EditActivity goBack={{}} />)}
            {!location.hash && <ActivityList />}
        </Box>
    )

}